export default __webpack_public_path__ + "static/media/pic2.f7c5f631.jpg";